import { ChangeEventHandler, MouseEventHandler } from "react";
import TextArea from "@ingka/text-area";
import { CSSProperties } from "styled-components";

import "@ingka/forms/dist/style.css";

interface TextAreaProps {
  id?: string;
  autoFocus?: boolean;
  label: string;
  value: string;
  readOnly?: boolean;
  onChange?: ChangeEventHandler<HTMLTextAreaElement>;
  onKeyDown?: (object: any) => void;
  style?: CSSProperties;
  onClick?: MouseEventHandler<HTMLTextAreaElement>;
  rows?: number | undefined;
  disabled?: boolean;
  "data-testid"?: string;
  className?: string;
}

export const FixaTextArea = (props: TextAreaProps) => {
  return <TextArea {...props} />;
};
